import { useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import SnackBar from "../../../components/SnackBar";
import { reprocessarSumarizacaoApuracao } from "../../../services/apuracao.service";
import { formatarCnpj } from "../utils";
import styles from "../styles.module.css";

/**
 * Reprocessar CAT-42 não tem "termos de exclusão" (esse conceito é de conta contábil,
 * do motor conciliacaosped/PIS-COFINS) — aqui é só recalcular o motor com as NF-e/CFOP
 * atuais. Por isso um modal simples, isolado do ModalReprocessarSumarizacao genérico.
 */
export default function ModalReprocessarCat42({ open, onClose, onSuccess, onError, apuracao, idApuracao }) {
  const [loading, setLoading] = useState(false);
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });

  const handleClose = () => {
    if (loading) return;
    onClose?.();
  };

  const handleConfirmar = async () => {
    if (!idApuracao) return;
    setLoading(true);
    try {
      const res = await reprocessarSumarizacaoApuracao(idApuracao, {});
      if (res?.sucesso) {
        onSuccess?.(res.mensagem || "Reprocessamento enfileirado.");
        handleClose();
      } else {
        const msg = res?.mensagem || "Não foi possível reprocessar a apuração.";
        onError?.(msg);
        setObjSnackBar({ type: "error", msg });
      }
    } catch (e) {
      const msg = e?.message || "Erro ao solicitar reprocessamento.";
      onError?.(msg);
      setObjSnackBar({ type: "error", msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>
          <div className={styles.title}>
            <RefreshIcon sx={{ marginRight: ".5rem" }} />
            Reprocessar apuração CAT-42
          </div>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <Typography>
            {formatarCnpj(apuracao?.cnpj)} — {apuracao?.empresa || "—"}
          </Typography>
          <Alert severity="info" sx={{ width: "100%", mt: 2 }}>
            Recalcula o motor CAT-42 (classificação, ressarcimento/complemento, saldo
            corrido) com os dados fiscais atuais. Não altera nenhum filtro — os NCMs e
            competências recalculados são os mesmos da apuração.
          </Alert>
        </DialogContent>

        <DialogActions className={styles.containerBtn}>
          <Button onClick={handleClose} variant="contained" className={styles.btnCancelar} disabled={loading}>
            Cancelar
          </Button>
          <Button onClick={handleConfirmar} variant="contained" className={styles.btnSalvar} disabled={loading}>
            {loading ? "Enfileirando…" : "Reprocessar"}
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={setObjSnackBar} />
    </>
  );
}
